import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { TeamPaymentRequestsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const clearPaymentRequest = (data): any => action(types.CLEAR_PAYMENT_REQUEST, data);

export const updatePaymentRequest = (data): any => action(types.UPDATE_PAYMENT_REQUEST, data);

export const createTeamPaymentRequest = (data): any => action(types.CREATE_TEAM_PAYMENT_REQUEST_REQUESTED, data);

export const updateTeamPaymentRequest = (data): any => action(types.UPDATE_TEAM_PAYMENT_REQUEST_REQUESTED, data);

export const deleteTeamPaymentRequest = (teamPaymentRequestId): any => action(types.UPDATE_TEAM_PAYMENT_REQUEST_REQUESTED, teamPaymentRequestId);

export const getTeamPaymentRequest = (teamPaymentRequestId): any => action(types.GET_TEAM_PAYMENT_REQUEST_REQUESTED, teamPaymentRequestId);

export const getAllTeamPaymentRequests = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_TEAM_PAYMENT_REQUESTS_REQUESTED, { pagination, compile });

export const selectTeamPaymentRequest = (teamPaymentRequestId): any => action(types.SELECT_TEAM_PAYMENT_REQUEST_REQUESTED, { currentTeamPaymentRequestId: teamPaymentRequestId });

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createTeamPaymentRequestPending: (payload): any => action(types.CREATE_TEAM_PAYMENT_REQUEST_PENDING, payload),
  createTeamPaymentRequestSuccess: (response): any => action(types.CREATE_TEAM_PAYMENT_REQUEST_SUCCESS, {
    teamPaymentRequestsById: response.entities.teamPaymentRequests,
    currentTeamPaymentRequestId: response.result,
  }),
  updateTeamPaymentRequestPending: (payload): any => action(types.UPDATE_TEAM_PAYMENT_REQUEST_PENDING, payload),
  updateTeamPaymentRequestSuccess: (response): any => action(types.UPDATE_TEAM_PAYMENT_REQUEST_SUCCESS, {
    teamPaymentRequestsById: response.entities.teamPaymentRequests,
    currentTeamPaymentRequestId: response.result,
  }),
  updateTeamPaymentRequestFailed: (error): any => action(types.UPDATE_TEAM_PAYMENT_REQUEST_FAIL, { backendErrors: error }),
  deleteTeamPaymentRequestPending: (): any => action(types.UPDATE_TEAM_PAYMENT_REQUEST_PENDING, {}),
  deleteTeamPaymentRequestSuccess: (response, userId): any => {
    localStorage.set(userId, { currentTeamPaymentRequestId: null });
    // history.push('/teamPaymentRequests');

    return action(types.DELETE_TEAM_PAYMENT_REQUEST_SUCCESS, {
      currentTeamPaymentRequestId: response,
    });
  },
  getTeamPaymentRequestPending: (): any => action(types.GET_TEAM_PAYMENT_REQUEST_PENDING, {}),
  getTeamPaymentRequestSuccess: (response): any => action(types.GET_TEAM_PAYMENT_REQUEST_SUCCESS, {
    teamPaymentRequestsById: response.entities.teamPaymentRequests,
    currentTeamPaymentRequestId: response.result,
  }),
  getTeamPaymentRequestFailed: (error): any => action(types.GET_TEAM_PAYMENT_REQUEST_FAIL, { backendErrors: error }),
  deleteTeamPaymentRequestFailed: (error): any => action(types.UPDATE_TEAM_PAYMENT_REQUEST_FAIL, { backendErrors: error }),
  getAllTeamPaymentRequestsPending: (pagination): any => action(types.GET_ALL_TEAM_PAYMENT_REQUESTS_PENDING, { pagination }),
  getAllTeamPaymentRequestsSuccess: (response, meta): any => action(types.GET_ALL_TEAM_PAYMENT_REQUESTS_SUCCESS, {
    teamPaymentRequestsById: response.entities.teamPaymentRequests,
    teamPaymentRequestIds: response.result,
    meta,
  }),
  getAllTeamPaymentRequestsFailed: (error): any => action(types.GET_ALL_TEAM_PAYMENT_REQUESTS_FAIL, { backendErrors: error }),
  createTeamPaymentRequestFailed: (error): any => action(types.CREATE_TEAM_PAYMENT_REQUEST_FAIL, { backendErrors: error }),
};

export default null;
